import { useEffect, useState } from 'react';
import { stockyApi } from '../components/misc/StockyApi';

// Reads the authenticated user's payment status ('ok' | 'warning' |
// 'critical' | 'overdue' | 'blocked') plus amount/due date from the backend. Purely a
// data hook: it never decides thresholds, it only reflects what the API
// already computed.
export function usePaymentStatus(authUser) {
  const [paymentStatus, setPaymentStatus] = useState('ok');
  const [nextPaymentAmount, setNextPaymentAmount] = useState(null);
  const [nextPaymentDueDate, setNextPaymentDueDate] = useState(null);
  const [isEmployee, setIsEmployee] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchPaymentStatus = async () => {
    if (!authUser) return;
    setLoading(true);
    try {
      const response = await stockyApi.getUserMe(authUser);
      setPaymentStatus(response?.data?.paymentStatus || 'ok');
      setIsEmployee(Boolean(response?.data?.ownerUserId));
      setNextPaymentAmount(
        response?.data?.nextPaymentAmount !== undefined ? response.data.nextPaymentAmount : null,
      );
      setNextPaymentDueDate(
        response?.data?.nextPaymentDueDate !== undefined ? response.data.nextPaymentDueDate : null,
      );
    } catch (error) {
      console.error('Error fetching payment status:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  return { paymentStatus, nextPaymentAmount, nextPaymentDueDate, isEmployee, loading, refetch: fetchPaymentStatus };
}
